import { useEffect, useRef } from 'react';
import { RunStatus } from '@rossum/api-client/hooks';
import { Stack } from '@rossum/ui/material';
import { isRunningJob } from '../../helpers';
import { useRunLogs } from '../../hooks/useRunLogs';
import { LogsContent } from './LogsContent';

export const LOGS_HEIGHT = 260;

type LogsProps = {
  runUuid: string | undefined;
  status: RunStatus | undefined;
};

export const Logs = ({ runUuid, status }: LogsProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const jobIsRunning = isRunningJob(status);

  const { data: runLogs, isLoading } = useRunLogs({
    runUuid: runUuid || '',
    refetchInterval: jobIsRunning ? 3000 : 0,
    refetchOnMount: jobIsRunning,
  });

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollTo({ top: ref.current.scrollHeight });
    }
  }, [runLogs]);

  return (
    <Stack
      ref={ref}
      spacing={1}
      sx={{
        p: 1,
        height: LOGS_HEIGHT,
        overflow: 'auto',
        fontFamily: "'Roboto Mono Variable', monospace",
        justifyContent: 'space-between',
      }}
    >
      <LogsContent
        logs={runLogs?.results}
        logsAreLoading={isLoading}
        runningStatus={jobIsRunning ? status : undefined}
      />
    </Stack>
  );
};
